import { semanticTokens } from "./tokens";
import { extendTheme } from "@chakra-ui/react";
import { components } from "./components";
import { breakpoints } from "./breakpoints";
import { fontSizes } from "./fontSizes";
import { colors } from "./colors";
import { fonts } from "./Fonts";

export const theme = extendTheme({
	fontSizes,
	breakpoints,
	semanticTokens,
	colors,
	fonts,
	components,
});
